import React from "react";

interface NewContentDotProps {
  /**
   * Optional class override. Defaults to the absolute top-right placement used by
   * tab triggers; pass a custom class for inline contexts (e.g. dropdown items).
   */
  className?: string;
}

/** Default placement: small blue dot pinned to a tab trigger's top-right corner. */
const DEFAULT_DOT_CLASS =
  "absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-blue-600 dark:bg-blue-400";

/**
 * The "new content" indicator dot shown on a tab (or dropdown item) whose asset
 * changed since the user last viewed it. Single source of truth for the dot
 * markup, shared by the fixed asset tabs, the additional-asset tabs, and the
 * "More" overflow menu.
 */
const NewContentDot: React.FC<NewContentDotProps> = ({ className }) => (
  <span className={className ?? DEFAULT_DOT_CLASS} />
);

export default NewContentDot;
